import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Quiz/Consent/Consent.css";

function GeminiConsent() {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleNext = () => {
    localStorage.setItem("geminiConsent", "true");
    navigate("/gemini-chat");
  };

  function handleCheck(event) {
    setIsChecked(event.target.checked);
  }

  return (
    <div className="exp-statement-container">
      <header className="dash-header">
        <button onClick={() => navigate("/dashboard")}>Dashboard</button>
      </header>
      <h1>Consent to Use Google Gemini</h1>
      <div className="scroll-box">
        <h3>Google Gemini Data Consent</h3>
        <p>
          <b>Purpose:</b> This feature allows you to interact with Google Gemini, an AI language model provided by Google. To use this feature, your input data (including your questions, demographic information, and recommendations) will be securely sent to Google servers for processing and response generation.<br /><br />
          <b>What data is sent?</b> When you use the Gemini chat, your questions, profile demographics, and recommendations are transmitted to Google. Google may store and use this data to improve its services, in accordance with its <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.<br /><br />
          <b>Risks:</b> While we take care to protect your privacy, data sent to Google is subject to their privacy and security practices. Please do not include sensitive personal information in your questions.<br /><br />
          <b>Withdrawing Consent:</b> You may choose not to use the Gemini feature if you do not wish your data to be sent to Google. You can return to the dashboard at any time.<br /><br />
          <b>Contact:</b> For questions about data use, contact the research team or refer to Google's privacy policy linked above.
        </p>
      </div>
      <p className="consent-container">
        By ticking the consent box below, you agree to allow your data to be sent to Google Gemini for the purpose of generating responses to your queries. You understand the risks and privacy implications described above.
        <ul>
          <li>I understand my data will be sent to Google for processing.</li>
          <li>I have read and understood the privacy information above.</li>
          <li>I agree not to submit sensitive personal information.</li>
        </ul>
        Hereby, I certify that all the information above is correct. I understand that by clicking the "I consent" below, I am giving my consent to use the Gemini feature.
      </p>
      <div>
        <div className="consent-checkbox-row">
          <input
            type="checkbox"
            className="checkbox"
            onClick={handleCheck}
            id="consent-checkbox"
          />
          <b>I consent</b>
          <button
            className="next-btn"
            onClick={handleNext}
            disabled={!isChecked}
            style={{ marginLeft: "auto" }}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default GeminiConsent;
